import React, { Fragment } from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

/***

examples of use:

	<WithOverlay text="my overlay 1">
		Salut les amis!
	</WithOverlay>


	<WithOverlay text="overlay 2">
		<Button>Hover me to see</Button>
	</WithOverlay>

	--- USAGE ---

	import WithOverlay from "./WithOverlay.js"
	
	ensuite:

	{
		<WithOverlay text="overlay 1">
			Salut les amis!
		</WithOverlay>
	}
	<br/><br/><br/>

	import Button from 'react-bootstrap/Button';

	{
		<WithOverlay text="overlay 2">
			<Button>Hover me to see</Button>
		</WithOverlay>
	}

***/

class RenderTooltip extends React.Component {
	constructor(props) {
		super(props)
		this.myRef = React.createRef();
	}
	render() {
		return (
			<Fragment>
				<div className="tooltip">
					<Tooltip {...this.props} arrowProps={{ ref: this.myRef }} className=" tooltip-inner">
						<div ref={this.myRef} className="arrow_box_downarrow"></div>
						{this.props.text}
					</Tooltip>
				</div>
			</Fragment>
		)
	}
}
class WithOverlay extends React.Component {
	/*	props:
			- text="my text"
				the text to show with the hover description
			- forceshow="true" ou forceshow={true} => affiche tout le temps, ex pour "copié!"
				sinon il affiche que en onMouseOver
	*/
	constructor(props) {
		super(props)
		this.myRef = React.createRef();

		this.tooltip_top = null
		this.tooltip_left = null
	}
	/*
	componentDidMount(){
		const function_id = "WithOverlay -> componentDidMount() : "
		const divref = this.myRef.current
		if(!divref) return

		//console.log(function_id+" divref.getBoundingClientRect() : ",divref.getBoundingClientRect())
		var positions = divref.getBoundingClientRect()
		var curr_top  = positions.top 
		var curr_left = positions.left

		if(curr_top  && curr_top > 0)  this.tooltip_top  = curr_top
		if(curr_left && curr_left > 0) this.tooltip_left = curr_left

		// TODO try to use these to set the ref tooltip at the right place ?

		console.log(function_id+"\n this.tooltip_top = "+this.tooltip_top+" \n this.tooltip_left = "+this.tooltip_left)
	}
	*/
	render() {
		// <div style={{display: "inline-block"}}>{props.children}</div>
		//  inline-block ensures the div is as small as possible
		// 		so that the overlays is at the center of the content
		// (previously table-cell but had some display bugs)
		const props = this.props

		//count how many children:
		var count = React.Children.count(props.children)

		// check children type:
		var type = typeof React.Children.toArray(props.children)[0]
		var content = ""
		if (type == "string") { // if simple string let's add a div
			content =
				<div style={{ display: "inline-block" }}>
					{props.children}
				</div>
		} else {
			content = props.children
		}

		var content_jsx =
			<div style={{ display: "inline-block" }} ref={this.myRef}>
				{content}
			</div>

		var placement = "top" // bottom, top, etc

		if (props.forceshow === "true" || props.forceshow === true) {
			return (
				<OverlayTrigger
					defaultShow={true}
					trigger="click"
					placement={placement}
					overlay={<Tooltip>{props.text}</Tooltip>}
				>
					{content_jsx}
				</OverlayTrigger>
			)
		}
		else { // use defaultShow={true} to debug the positioning // BEWARE THESE DO NOT SHOW UP ON DEVELOPMENT BUT DO WORK IN PRODUCTION
			return (
				<OverlayTrigger
					placement={placement}
					overlay={<Tooltip>{props.text}</Tooltip>}
				>
					{content_jsx}
				</OverlayTrigger>
			)
		}
	}
}
export default WithOverlay
